//(function ($) {
//    //class rules - used to refactor common combinations of rules into a single class
//    //global class rules: (if custom classes is needed in a project we should add them in another addClassRules function next to the custom messages "jQuery.extend(jQuery.validator.messages" )
    
//    validateZip = false;
//    if(validateZip){
//        var dkzips = new Bloodhound({
//            initialize: false,
//            identify: function(obj) { return obj.nr; },
//            datumTokenizer: Bloodhound.tokenizers.whitespace,
//            queryTokenizer: Bloodhound.tokenizers.whitespace,
//            prefetch: {
//                cache: false, //remove this when not debugging
//                url: "https://dawa.aws.dk/postnumre"
//            }
//        });
        
//        dkzips.initialize().done(function (e,v) {
//            //check returned data
//            //set validation to use data
//            console.log('ready to go!');
//        }).fail(function () {
//            //switch to default validation 
//            console.log('err, something went wrong :(');
//        });
//    }


//    validateAddress = true;
//    var dkAddresses;
//    /*
//    if (validateAddress) {
//        //set-up typeahead

//        var dkzips = new Bloodhound({
//            initialize: false,
//            identify: function (obj) { return obj.nr; },
//            datumTokenizer: Bloodhound.tokenizers.whitespace,
//            queryTokenizer: Bloodhound.tokenizers.whitespace,
//            prefetch: {
//                cache: false, //remove this when not debugging
//                url: "https://dawa.aws.dk/postnumre"
//            }
//        });

//        dkzips.initialize().done(function (e, v) {
//            //check returned data
//            //set validation to use data
//            //console.log(dkzips.get(2860));
//            console.log('ready to go!');
//        }).fail(function () {
//            //switch to default validation 
//            console.log('err, something went wrong :(');
//        });
//    }*/

//    //!! the postal code field should have its rules applied dynamically -> fetch the rules remote..

//        /*
//    $.validator.addMethod('postalcode-dk', function (value, element) {
//        if(this.optional(element)){
//            return true;
//        }
//        if (true) { //maybe use something dynamic here so we dont need a function for each type of postcode..
//            var res = dkzips.get(value);
//            if (res.length == 1 && res[0].navn !== null) {
//                //update city field
//                $(element.getAttribute("update-city-field")).val(res[0].navn);//.valid();

//                //load addresses for current city
//                if (validateAddress) {
//                    dkAddresses = new Bloodhound({
//                        identify: function (obj) { return obj.nr; },
//                        datumTokenizer: Bloodhound.tokenizers.whitespace,
//                        queryTokenizer: Bloodhound.tokenizers.whitespace,
//                        remote: {
//                           // cache: false, //remove this when not debugging
//                            url: "https://dawa.aws.dk/adresser?q=%QUERY*&postnr=" + value, // maybe we should just re-init when a new postnr has been validated
//                            wildcard: '%QUERY'
//                        }
//                    });
//                }


//                //$(element.getAttribute("update-city-field")).trigger('input');
//                //setTimeout(function (element) { $(element.getAttribute("update-city-field")).valid(); }(element), 10000);
//                //$(element.getAttribute("update-city-field")).valid();
//                return true;
//            } else return false;
//        }
        
//    }, "Invalid postal code");*/


    
//    $.validator.methods.email = function (value, element) {
//        return this.optional(element) || /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/i.test(value);
//    }
    

//    $.validator.setDefaults({
//        ignoreTitle: true,
//        highlight: function (element) {
//            if ($(element).is(":focus")) {
//                $(element).closest('.form-group').removeClass('has-success').removeClass('has-danger').addClass('has-warning');
//                $(element).removeClass('form-control-success').removeClass('form-control-danger').addClass('form-control-warning');
//            } else {
//                $(element).closest('.form-group').removeClass('has-success').removeClass('has-warning').addClass('has-danger');
//                $(element).removeClass('form-control-success').removeClass('form-control-warning').addClass('form-control-danger');
//            }
//        },
//        unhighlight: function (element) {
//            $(element).closest('.form-group').removeClass('has-warning').removeClass('has-danger').addClass('has-success');
//            $(element).removeClass('form-control-warning').removeClass('form-control-danger').addClass('form-control-success');
//        },
//        onfocusout: function (element) {
//            $(element).valid();
//        },
//        errorElement: 'small',
//        errorClass: 'form-control-feedback',
//        errorPlacement: function (error, element) {
//            if (element.parent('.input-group').length) {
//                error.insertAfter(element.parent());
//            } else {
//                error.insertAfter(element);
//            }
//        }
//    });

//    $(function () {
//        $(".form-control").focus(function (element) {
//            $(element.target).valid();
//        }).on('input', function (element) {
//            if (element.target.value.length > 0) {
//                $(element.target).closest('.form-group').addClass('has-value'); //maybe use the ':filled' selector ?? this is only a jquery selector!
//            } else {
//                $(element.target).closest('.form-group').removeClass('has-value');
//            }
//            $(element.target).valid();
//        });
//    });

//})(jQuery);


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function validateFields(parent) {
    //console.log("validating fields");
    //console.log(parent);
    var numFalse = 0;
    // Check all required fields
    parent.find(".js-req, .js-validate").each(function () {
        //console.log("Validating Field - " + $(this).attr("name"));
        
        var parentItem = $(this).parent();
        if ($(this).hasClass("js-clear")) parentItem = $(this).parent().parent();

        // Reset all errormessages
        parentItem.find(".js-invalid-nofill").addClass("display-none");

        // Check if empty
        if ($(this).hasClass("js-req") && $(this).val() === "") {
            //console.log("empty");
            $(this).addClass("invalid-field");
            parentItem.find(".js-invalid-nofill").removeClass("display-none");
            numFalse++;
        } else {
            
            // If not empty, check specifics
            if (!validateField($(this), parent)) {
//                console.log("invalid");
                $(this).addClass("invalid-field");
                numFalse++;
            } else {
                //console.log("valid");
                $(this).removeClass("invalid-field");
            }
        }
        validateCountryCart(parent);
    });

    if (!validateServicePoints()) {
        //console.log("invalid-service-point");
        numFalse++;
    }
    //// On errors, focus first invalid field
    //var numFalseCheck = 0;
    //if (!validateLocations()) numFalseCheck++;
    //if (!validateTaskTypes()) numFalseCheck++;

    //if (numFalseCheck > 0) {
    //    //console.log("chek_false");
    //    $('body').scrollTop($(".invalid-check").first().offset().top - 200);
    //    return false;
    //}
    //else if (numFalse > 0) {
    //    $(".invalid-field").first().focus();
    //    return false;
    //}

    if (numFalse > 0) {
        $(".invalid-field", parent).first().focus();
        return false;
    }
    // Else
    return true;
}

function validateField(field, parentItem) {
    //console.log("2");

    var isNum;
    var numFalse = 0;

    if (field.hasClass("js-integer")) {
        var str = field.val();
        //console.log("|" + str + "|");
        isNum = /^\d+$/.test(str);
        if (!isNum) {
            $('.js-invalid-integer', parentItem).removeClass("display-none");
            return false;
        } else {
            //console.log("isInteger");
            $('.js-invalid-integer', parentItem).addClass("display-none");
        }
    }

    if (field.hasClass("js-phone")) {
        var str = field.val().replace(/\s/g, '');
        str = str.replace(/-/g, '');
        str = str.replace(/\+/g, '');
        isNum = /^\d+$/.test(str);
        if (!isNum) {
            $('.js-invalid-phone', parentItem).removeClass("display-none");
            return false;
        }
    }

    if (field.hasClass("js-email")) {
        var isMail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(field.val());
        if (!isMail) {
            $(".js-invalid-email", parentItem).removeClass("display-none");
            return false;
        } else {
            $(".js-invalid-email", parentItem).addClass("display-none");
        }
    }

    if (field.hasClass("js-password-confirm")) {
        if (field.val() !== $(".js-password").val() && !(field.val() === "" && $(".js-password").val() === "")) {
            $(".js-invalid-password-confirm", parentItem).removeClass("display-none");
            return false;
        } else {
            $(".js-invalid-password-confirm", parentItem).addClass("display-none");
        }
    }

    if (field.hasClass("js-conditions")) {
        if (!field.prop("checked")) {
            $(".js-invalid-notchecked", parentItem).removeClass("display-none");
            return false;
        } else {
            $(".js-invalid-notchecked", parentItem).addClass("display-none");
        }
    }
    return true;
}

function validateCountryCart(parentItem) {
    $('.js-country-cart', parentItem).each(function () {
        if (($(this).hasClass('js-req')) && (($(this).val() == "no-country") || (!$(this).val()))) {
            $(this).next('.js-invalid-country-nofill').removeClass("display-none");
            return false;
        }
        else {
            $(this).next('.js-invalid-country-nofill').addClass("display-none");
            return true;
        }
    });
}

function validateLocations() {
    var numChecked = 0;
    $(".js-location").each(function () {
        if ($(this).prop("checked")) {
            numChecked++;
        }
    });
    if (numChecked == 0 && $(".js-location").length > 0) {
        $(".js-location-error").removeClass("display-none").addClass("invalid-check");
        return false;
    } else {
        $(".js-location-error").removeClass("invalid-check");
        if (!$(".js-location-error").hasClass("display-none")) $(".js-location-error").addClass("display-none");
        return true;
    }
}

function validateTaskTypes() {
    var numChecked = 0;
    $(".js-tasktype").each(function () {
        if ($(this).prop("checked")) {
            numChecked++;
        }
    });
    if (numChecked == 0 && $(".js-tasktype").length > 0) {
        $(".js-tasktype-error").removeClass("display-none").addClass("invalid-check");
        return false;
    } else {
        $(".js-tasktype-error").removeClass("invalid-check");
        if (!$(".js-tasktype-error").hasClass("display-none")) $(".js-tasktype-error").addClass("display-none");
        return true;
    }
}

function validateServicePoints() {
    if (!$(".js-service-point-method-radio").prop("checked") || $('.js-service-point-radio:checked').length > 0) {
        $(".js-invalid-service-point").addClass("display-none");
        return true;
    } else {
        $(".js-invalid-service-point").removeClass("display-none");
        $(".js-service-point-method-radio").addClass("invalid-field");
        return false;
    }
}
